import React, { ReactNode, useEffect, ReactElement } from 'react'

import { Page } from '../../design-system'
import { PageHeader2019 } from '../molecules/page-header'
import { PageFooter2019 } from '../molecules/page-footer'
import { lightTheme2019, darkTheme2019 } from '../theme'
import { useScrollSpyChildren, event as analyticsEvent } from '../../services'
import { ErrorView } from '../molecules'
import { ErrorMessage } from './error'

interface TWT2019PageProps {
  title?: string
  children?: ReactNode
  page?: ReactNode
  cover?: ReactNode
  headerBg?: ReactElement
  light?: boolean
  description?: string
  image?: string
}

export const Page2019 = ({
  title,
  children,
  light,
  cover,
  headerBg,
  image = 'https://theworldtransformed.org/splash.png"',
  description = 'A 4-day politics, arts and music festival running alongside the Labour Party Conference. Brighton, September 21-24.',
}: TWT2019PageProps) => {
  const [spyChildren, current] = useScrollSpyChildren({
    children,
    container: '#___gatsby > *',
  })

  useEffect(() => {
    if (current && current.id) {
      analyticsEvent(current.id)
    }
  }, [current])

  return (
    <Page
      title={title}
      titlePrefix="TWT19"
      theme={light ? lightTheme2019 : darkTheme2019}
      splashImage={image}
      description={description}
    >
      <PageHeader2019 headerBg={headerBg}>{cover}</PageHeader2019>
      <ErrorView message={<ErrorMessage />}>{spyChildren}</ErrorView>
      <PageFooter2019 />
    </Page>
  )
}
